export default {
  ORDER_BY: 'orderBy',
  DEPARTING_ORDER_BY: 'departingOrderBy',
  FLIGHTS_DEFAULT_ORDER: 'less_scales'
}
